/**
 * Display the average amount of amplitude across a range
 * of frequencies using the p5.FFT class and its methods analyze()
 * and logAverages().
 *
 * This example divides the frequency spectrum into the first 11 octave bands.
 * https://courses.physics.illinois.edu/phys193/labs/octave_bands.pdf
 */

var soundFile;
var fft;

var description = 'loading';
var p;
var barsNumber;
var octaveBands;
var remainingTime;

window.preload = function() {
    soundFormats('mp3', 'ogg');
    //soundFile = loadSound('../files/lucky_dragons_-_power_melody');
};

var currentOmTime;

var options = {
    maxValue: 100,
    requiredStep: 45,
    samplesAmount: 45,
    requiredTotalOmm: 12000,
    minimalOmmTime: 200
};

var ended = false;

window.setup = function() {

    console.log('SETUP FUNCTION!!!!');

    createCanvas(300, 400);
    fill(255, 40, 255);
    noStroke();
    textAlign(CENTER);

    filter = new p5.BandPass();
    filter.set();

    window.mic = new p5.AudioIn();

    //  mic.disconnect();
    // mic.connect(filter);

    window.mic.start();
    fft = new p5.FFT();
    fft.setInput(window.mic);

    ended = false;
    window.micValuesToAvg = [];

    //fft = new p5.FFT();
    window.initialMikeValue = undefined;

    // p = createP('please do OMMMM');
    // pRemainingTime = createP('');
    octaveBands = fft.getOctaveBands();
    // console.log(octaveBands);
    barsNumber = octaveBands.length;

    var startButton = document.querySelector('#startButton');
    var startBox = document.querySelector('#startBox');
    var actionBox = document.querySelector('#actionBox');
    currentOmTime = options.ommRequiredTime;

    currentTimeout = undefined;

    remainingTime = 0;
    console.log('remainingTime ', remainingTime );

    timeEnd = null;
    timeStart = null;


    // startButton.addEventListener('click', function(){


    //     startBox.style.display = 'none';
    //     actionBox.style.display = 'block';
    //
    // });

}

var filterFreq, filterWidth;
var ommArr = [], ommArrLimit = 25;

var timeStart = null, timeEnd = null, isOmm = false, wasOmm = false;
var ommAvg;
var currentTimeout;

function summationAVG(summationArr){

    let sum = summationArr.reduce((x, y) => x + y);
    return sum/summationArr.length;

}

window.draw = function() {

    if(ended) return;

    console.log('DRAW');

    if(!window.initialMikeValue)
        if(window.mic.getLevel()*100/0.01){

            if(window.micValuesToAvg.length > 100) {
                window.initialMikeValue = Math.min(summationAVG(window.micValuesToAvg), 80);

                window.micValuesToAvg = [];
            } else {
                window.micValuesToAvg.push(window.mic.getLevel()*100/0.01);
            }
        }

    background(30,20,30);

    //updateDescription();

    // Map mouseX to a bandpass freq from the FFT spectrum range: 10Hz - 22050Hz
    filterFreq = map(mouseX, 0, width, 10, 1050);
    // Map mouseY to resonance/width
    filterWidth = map(mouseY, 0, height, 0, 90);
    // set filter parameters
    filter.set(filterFreq, filterWidth);
    //console.log(filterFreq, filterWidth);

    fft.analyze(); // analyze before calling fft.logAverages()
    var groupedFrequencies = fft.logAverages(octaveBands);
//console.log(groupedFrequencies);

//console.log('xs',parseInt(fft.getEnergy("bass")/300*100));

    var avg = (fft.getEnergy("bass") + fft.getEnergy("lowMid") + fft.getEnergy("mid") + fft.getEnergy("highMid") + fft.getEnergy("treble")) / 5;

//console.log(parseInt(fft.getEnergy("bass")), avg);
//var omm = parseInt((fft.getEnergy(50)+fft.getEnergy(150))/2- avg)
    //var omm = parseInt((fft.getEnergy("bass")) - avg)

    var omm = Math.max(
        parseInt((fft.getEnergy("bass")) - avg),
        parseInt((fft.getEnergy("lowMid")) - avg),
        parseInt(fft.getEnergy("highMid") - avg),
        parseInt(fft.getEnergy("mid") - avg),
    );

    var currentMicValue = window.mic.getLevel()*100/0.01;
    //console.log('currentMicValue',currentMicValue);

    if(window.initialMikeValue)
        var currentChangePercent = currentMicValue/window.initialMikeValue * 100;


    var iOS = navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false;
    omm = iOS ? (window.initialMikeValue && currentChangePercent > 200 ? omm : omm * 0.4) : omm;

    ommArr.push(omm);

    if (ommArr.length > options.samplesAmount)
        ommArr = ommArr.slice(Math.max(ommArr.length - options.samplesAmount, 1))

    ommAvg = ommArr.reduce(function (a, b) {
        return a + b;
    }) / options.samplesAmount;

    if (ommAvg > options.requiredStep - 5) {
        if (ommAvg > options.requiredStep) {
            // console.log(ommAvg, 'OMMMM');
            isOmm = true;

        } else {
            isOmm = false;
            // console.log('avg', ommAvg);
        }

        wasOmm = isOmm;
    }

    if(!currentTimeout) currentTimeout = new Date().getTime();

    if(new Date().getTime() - currentTimeout < 400) {
        return;
    }else {
        currentTimeout = new Date().getTime();
    }


    if (isOmm) {
        try {
            document.querySelector('#afterFirstActionCorrect').style.display = 'block';
        } catch(e){}

        if (timeStart == null) {
            timeStart = new Date()
        } else {

            var ommLength = parseInt(new Date().getTime() - timeStart.getTime());

            if(ommLength < options.minimalOmmTime) return;

            if ((remainingTime < 13000) && (ommLength > options.minimalOmmTime))
                remainingTime += ommLength;

            if (remainingTime > 12000) remainingTime = 12000;

            var pRemainingTime = document.querySelector('#shakeCountElem');

            console.log(parseInt(remainingTime / 1000.0) < 10 ? '0' +  String(parseInt(remainingTime / 1000.0)) : String(parseInt(remainingTime / 1000.0)))

            pRemainingTime.innerHTML = parseInt(remainingTime / 1000.0) < 10 ? '0' +  String(parseInt(remainingTime / 1000.0)) : String(parseInt(remainingTime / 1000.0));

            if(remainingTime == 12000 ) {

                var text = document.querySelector('.text-info');
                text.innerHTML = "Herzliche Gratulation!<br>Du hast es geschafft. ";

                var button = document.querySelector('#nextButton');
                button.removeAttribute('disabled');
                document.querySelector('.box__background-width').style.left = '100%';
                ended = true;

            }

            timeStart = new Date()
        };
    } else {
        if (timeEnd == null && timeStart) timeEnd = new Date();

        if (timeStart && timeEnd) {
            var ommLength = parseInt(timeEnd - timeStart);
            // console.log('Omm length: ' +  String(ommLength) + "ms");
            // p.html('Omm length: ' +  String(ommLength) + "ms");

            if ((remainingTime < 13000) && (ommLength > options.minimalOmmTime))
                remainingTime += ommLength;

            if (remainingTime > 12000) remainingTime = 12000;

            var pRemainingTime = document.querySelector('#shakeCountElem');
            console.log('from else', parseInt(remainingTime / 1000.0) < 10 ? '0' +  String(parseInt(remainingTime / 1000.0)) : String(parseInt(remainingTime / 1000.0)));
            pRemainingTime.innerHTML = parseInt(remainingTime / 1000.0) < 10 ? '0' +  String(parseInt(remainingTime / 1000.0)) : String(parseInt(remainingTime / 1000.0));


            timeStart = null;
            timeEnd = null;
            if(remainingTime == 12000 ) {
                var text = document.querySelector('.text-info');
                text.innerHTML = "Herzliche Gratulation!<br> Du hast es geschafft. ";
                var button = document.querySelector('#nextButton');
                button.removeAttribute('disabled');
                document.querySelector('.box__background-width').style.left = '100%';
                ended = true;
            }
        }
    }

//console.log(timeStart, timeEnd);

//,(fft.getEnergy("bass")),fft.getEnergy("lowMid"),fft.getEnergy("mid"),fft.getEnergy("highMid"),fft.getEnergy("treble"));

    //Generate the bars to represent the different frequency averages per group

    if(ended) return;

    barsNumber = 1;
    for (var i = 0; i < barsNumber; i++) {
        noStroke();
        fill((i * 30) % 100 + 50, 195, ((i * 25) + 50) % 100);

        // Rectangle height represents the average value of this frequency range
        var h = -height + map(ommAvg, 0, 200, height, 0);
        // console.log('h', h);
        rect(((i + 1) * width / barsNumber) - width / barsNumber, height, width / barsNumber, h);

        fill(255, 255, 255);

        // Rectangle height represents the average value of this frequency range
        var h2 = map(options.requiredStep, 0, 200, height, 0);
        rect(0, h2, width, 2);

        fill(255,0,0);
    }

    if(isOmm) {
        document.querySelector('.box__background-width').style.left = Math.abs(h)/(height/2)*100*1.3  + '%';
    } else {
        document.querySelector('.box__background-width').style.left = '20%';
    }


}

function isMouseOverCanvas() {
    var mX = mouseX, mY = mouseY;
    /*if (mX > 0 && mX < width && mY < height && mY > 0) {
     noise.amp(0.5, 0.2);
     } else {
     noise.amp(0, 0.2);
     }*/
}

// Helper function for drawing the group ranges
function calcFreqFromIndex(index) {
    var nyquist = sampleRate() / 2;
    var indexFrequency = Math.round((index * nyquist) / fft.bins);

    return (indexFrequency);
}

function keyPressed() {
    if (soundFile.isPlaying()) {
        soundFile.pause();
    } else {
        soundFile.loop();
    }
}

// Change description text if the song is loading, playing or paused
function updateDescription() {
    //p.html(description);
}
function updateOmTimeInView(currentTime){
    var time = Math.ceil(currentTime);
    // shakeCountElem.innerHTLM = time;
}

(function () {

    // var gui = new dat.GUI();
    // //gui.add(this.options, 'maxValue', 10, 100);
    // gui.add(this.options, 'requiredStep', 10, 100);
    // gui.add(this.options, 'samplesAmount', 5, 100);
    // gui.add(this.options, 'requiredTotalOmm', 5000, 10000);
    // gui.add(this.options, 'minimalOmmTime', 50, 1000);

})();